import { ChangeDetectionStrategy, Component, computed, forwardRef, inject, input, model, OnInit, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { OpsRegion } from 'src/app/api/commonInterfaces';
import { OpsRegionService } from 'src/app/api/ops-region.service';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'app-ops-region-dropdown',
  imports: [SelectModule, FormsModule, MultiSelectModule],
  templateUrl: './ops-region-dropdown.component.html',
  styleUrl: './ops-region-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OpsRegionDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpsRegionDropdownComponent implements OnInit, ControlValueAccessor {


  private writtenValue: any

  placeholder = input<string>("Select a Region")
  selectAllByDefault = input<boolean>(false)

  writeValue(obj: any): void {
    this.writtenValue = obj
    if (Array.isArray(obj)) {
      this.setSelectedRegions(obj)
    }
    else if (obj === null) {
      this.setSelectedRegions([])
    }
    else {
      this.setSelectedRegions([obj])
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }


  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;

  opsRegionService = inject(OpsRegionService)

  opsRegions = signal<OpsRegion[]>([])

  dropdownOptions = computed(() => this.opsRegions().map(r => ({ label: r.name, value: r })))

  selectedOpsRegions = model<OpsRegion[]>([])

  ngOnInit(): void {
    this.opsRegionService.getOpsRegions().subscribe(opsRegions => {
      this.opsRegions.set(opsRegions)
      //need to handle the case where ngmodel writes the value before we're initialized
      if (this.writtenValue) {
        this.setSelectedRegions(this.writtenValue)
      }
      else if (this.selectAllByDefault()) {
        this.setSelectedRegions(opsRegions)
        this.onChange(opsRegions)
      }
    })
  }

  setSelectedRegions(regions: OpsRegion[]) {
    this.selectedOpsRegions.set(this.opsRegions().filter(r => regions.some(s => s.id === r.id)))

  }

  onRegionSelected(event: SelectChangeEvent) {
    this.onChange(event.value)
  }


}
